import React,{useEffect,useRef} from 'react';
import {X} from 'lucide-react';
import './DataWorkspace.css';
export default function WorkspacePopup({isOpen,title,subtitle,onClose,actions,children,className='',closeDisabled=false,closeLabel}) {
 const dialog=useRef(null);
 useEffect(()=>{
  if(!isOpen)return undefined;
  const node=dialog.current;if(node&&!node.open)node.showModal();
  const previous=document.body.style.overflow;document.body.style.overflow='hidden';
  return()=>{node?.close();document.body.style.overflow=previous;};
 },[isOpen]);
 if(!isOpen)return null;
 return <dialog ref={dialog} className={'aq-popup '+className} aria-label={title} onCancel={event=>{event.preventDefault();if(!closeDisabled)onClose();}}>
  <header className="aq-popup-head"><div><h2>{title}</h2>{subtitle&&<p>{subtitle}</p>}</div><div className="aq-tools">{actions}<button aria-label={closeLabel||'Close '+title.toLowerCase()} disabled={closeDisabled} onClick={onClose}><X size={18}/></button></div></header>
  <div className="aq-popup-body">{children}</div>
 </dialog>;
}
